import * as React from 'react'

import { styled, spacing, mq } from '@thg-commerce/gravity-theme'
import { SafeHtml } from '@thg-commerce/gravity-elements'

import {
  AuthorDetailsProps,
  AuthorDetails,
} from '../AuthorDetails/AuthorDetails'
import { sizeLarge as imageSize } from '../AuthorDetails/AuthorImage/AuthorImage'

interface Props {
  bio: string
}

export type AuthorInformationProps = Props & AuthorDetailsProps

const Bio = styled(SafeHtml)`
  margin-left: 0;
  margin-top: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-left: calc(${imageSize}px + ${spacing(2)} - 2px);
    margin-top: 0;
  }
`

export const AuthorInformation = ({
  bio,
  ...authorDetails
}: AuthorInformationProps) => (
  <div>
    {authorDetails.isAmp ? (
      <AuthorDetails {...authorDetails} />
    ) : (
      <AuthorDetails {...authorDetails} imageSizes={['small', 'large']} />
    )}

    <Bio content={bio} />
  </div>
)
